<template>
  <div class="py-3 h-100">
    <div class="d-flex justify-content-between align-items-center">
      <p class="my-4">PQP</p>
      <div>
        <button class="btn btn-primary" @click="promptAddFile()">
          <i class="fa-solid fa-file-upload me-2" />
          Upload PDF
        </button>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-dark">
        <thead>
          <tr>
            <th style="width: 5%">#</th>
            <th>Name</th>
            <th style="width: 10%" class="text-center">File</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(pqp, index) in pqps" :key="`pqp-${pqp.id}-${index}`">
            <td>{{ index + 1 }}</td>
            <td>{{ pqp.name }}</td>
            <td class="text-center">
              <button
                class="btn btn-link text-light"
                @click="currentPdf = Helper.formatMediaUrl(pqp.file)"
              >
                <i class="fas fa-file-pdf fa-2x" />
              </button>
            </td>
          </tr>
          <tr v-if="!pqps.length">
            <td colspan="4" class="text-center fst-italic py-4">
              No file uploaded
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <pdf-viewer
      :url="currentPdf"
      v-if="currentPdf"
      @close="currentPdf = null"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import PdfViewer from "@/components/PdfViewer";

export default {
  props: ["componentId", "status", "pavementId"],
  components: { PdfViewer },
  data() {
    return {
      pqps: [],
      pdfUrl: null,
      fileInput: null,
      currentPdf: null,
    };
  },
  methods: {
    async promptAddFile() {
      const { value: file } = await Swal.fire({
        title: "<h5 class='fw-bold'>Upload PQP File</h5>",
        html: "<div class='mb-3'><label class='form-label'>Enter file name</label><input class='form-control' id='addFileInput' /></div>",
        showCancelButton: true,
        input: "file",
        inputAttributes: {
          accept: "application/pdf",
        },
        customClass: {
          input: "form-control",
        },
        inputValidator: (value) => {
          const fileName = document.getElementById("addFileInput").value;

          if (!fileName) return "File name is required";

          if (!value) return "No file selected";
        },
      });

      if (file) {
        this.Helper.toggleLoadingSpinner(true);

        this.fileInput = file;

        await this.uploadFileInput(
          document.getElementById("addFileInput").value
        );

        await this.getPqp();

        this.fileInput = null;

        this.Helper.toggleLoadingSpinner(false);

        this.triggerAlert("success", "File uploaded");
      }
    },
    async uploadFileInput(fileName) {
      return new Promise(async (resolve, reject) => {
        const data = {
          pavement_case: this.pavementId,
          name: fileName,
        };

        const formData = new FormData();

        formData.append("data", JSON.stringify(data));

        formData.append("files.file", this.fileInput, this.fileInput.name);

        const [call, error] = await this.Helper.handlePromise(
          this.API.postForm("pavement-pqps", formData)
        );

        if (error) {
          return reject(error);
        } else {
          return resolve("OK");
        }
      });
    },
    triggerAlert(icon, text, callback, callbackData) {
      Swal.fire({
        icon: icon,
        title: `<h5>${text}</h5>`,
      }).then(() => {
        if (callback) {
          this.$emit(callback, callbackData);
        }
      });
    },
    async getPqp() {
      if (this.pavementId) {
        this.Helper.toggleLoadingSpinner(true);

        const [call, error] = await this.Helper.handlePromise(
          this.API.get(`pavement-pqps?pavement_case=${this.pavementId}`)
        );

        if (error) {
          this.triggerAlert("error", "Error getting PQP data");
        } else {
          this.pqps = call.data;
        }

        this.Helper.toggleLoadingSpinner(false);
      }
    },
  },
  async mounted() {
    await this.getPqp();
  },
};
</script>